// import { AccountBalanceWalletRounded } from '@mui/icons-material'
import React from 'react'
import newIcon from '../../images/icons/etiquetaNuevo.png'

const style = {
   dot: {
      height: '8px',
      width: '8px',
      borderRadius: '50%',
      backgroundColor: '#37C846',
      display: 'inline-block',
      border: '1px solid white'
   }
}

export default function NewIconMainMenu() {
   return (
      <>
         <span style={style.status}>
            <span style={style.dot} />
         </span>
      </>
   )
}
